<template>
	<div>
		<v-dialog v-model="dialog_signature" scrollable fullscreen persistent :overlay="false" max-width="500px" no-click-animation transition="slide-y-transition">
	    	<v-card flat style="padding-top:56px !important">
                <v-toolbar flat fixed class="main_toolbar">
                    <v-toolbar-side-icon @click="$parent.fn_closeDialog"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
                    <v-toolbar-title>Signature</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn class="pr-0" flat color="primary" @click="fn_clearPad">Clear</v-btn>
                    <v-btn flat icon color="primary" @click="fn_saveImage"><v-icon>done</v-icon></v-btn>
                </v-toolbar>

                <v-alert type="info" :value="true">
                    Draw your signature within given box.
                </v-alert>
                
                <v-card-text>
                    <div class="wrapper" style="border:1px #ddd solid;height:200px" >
                        <canvas id="signature-pad" class="signature-pad" style="width:100%;height:100%"></canvas>   
                        <canvas id="cropped-canvas" class="cropped-canvas"></canvas>       
                    </div>

                    <!-- <div class="center-align pa-4">
                        <v-btn color="primary" @click="fn_saveImage">Done</v-btn>
                    </div> -->
                    
                </v-card-text>
            </v-card>
	    </v-dialog>
	</div>
</template>	 	

<script>

import SignaturePad from 'signature_pad';
// import trimCanvas from 'trim-canvas'

var canvas = null;
var signaturePad = null;

export default{
    props:['embedSignature'],
	data(){	
		return{
			dialog_signature: false
            // quillContent:null
		}
	},
	methods: {
		openDialogWeb: function () {	
            canvas = document.getElementById('signature-pad');
            signaturePad = new SignaturePad(canvas, {
              backgroundColor: 'rgb(255, 255, 255)' // necessary for saving image as JPEG; can be removed is only saving as PNG or SVG
            });
            
			this.dialog_signature = true;
		},
		closeDialogWeb: function () {
			this.dialog_signature = false;
		},
        fn_saveImage: function(){

            if (signaturePad.isEmpty()) {
                this.showToast("Please provide a signature");
                return
            }

            var dataUrl = signaturePad.toDataURL('image/png');
            console.log(dataUrl);

            this.embedSignature(dataUrl);
            
        },
        fn_clearPad: function(){
            signaturePad.clear();
        }
	}
}
</script>


// WEBPACK FOOTER //
// src/components/print_fields/dialogs/dialog_signature.vue